export enum Origin {
  Italian = 'it',
  Foreign = 'fr',
}
